import { useLiveClock } from './useLiveClock';

/**
 * Server-authoritative clock for a page with no live feed of its own.
 *
 * 🔴 NO LONGER A COPY. This hook held the website's own implementation of the
 * `get_server_time` sampling the shared client already had
 * (`startServerClock`) — two implementations of "what time does the server
 * say it is" (memory: feedback_no_mechanical_divergence). It is now the shared
 * `createLiveClock` through `useLiveClock`, with no feed: one sample on mount
 * and one a minute, the same behaviour as before.
 *
 * A page that HAS a feed (the Lots page, the lot page) calls `useLiveClock`
 * with it instead, and reads the engine's clock.
 */
export function useServerClock(): { nowServerMs: () => number } {
  return { nowServerMs: useLiveClock(null) };
}
